const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/networkReducer.ts';
import Imm from 'immutable';
import { atCacheRequest, atClearCache, atCheckConnectivity, atSetCurrentBaseUrl } from '../actions/networkActions';

export const initialState: any = Imm.fromJS({
    online: true,
    cache: {},
    currentBaseUrl: null,
});

export function networkReducer(state = initialState, action: any = {}) {
    switch (action.type) {
        case atCacheRequest:
            return state.setIn(['cache', action.payload.key], Imm.fromJS(action.payload.data));

        case atClearCache:
            return state.deleteIn(['cache', action.payload.key]);

        case atCheckConnectivity.success:
            return state.set('online', true);
        case atCheckConnectivity.failure:
            return state.set('online', false);

        case atSetCurrentBaseUrl:
            return state.set('currentBaseUrl', action?.payload?.baseUrl || null);

        default:
            return state;
    }
}
